export const CotributeLogo = require("./cotribute-logo.svg") as string;
